import type { FaireProductEntity } from "../../entity_types/product";

export const p_45ut8jezj7: FaireProductEntity = {
  token: "p_45ut8jezj7",
  type: "product",
  name: "SHORT SLEEVE KNIT SIDE SLIT MIDI DRESS",
  brandToken: "b_2a388unpqo",
  brandName: "Bluivy",
  imageUrl:
    "https://cdn.faire.com/fastly/9887b270d712f348944fe29b081cea45f9937b9a2ce2ba5346795e76c12386fc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bcf629e08e846d83e22b7ddee363bba87124b22bb67aab10d8b0e21236c68c70.jpeg",
    "https://cdn.faire.com/fastly/f2e10ef89b2e792f8bc69f57d56b0a71bbab718a64e0bca8d11986aa463c44fd.jpeg",
    "https://cdn.faire.com/fastly/2e38bdc37861824496ce0820a5ae8f309a579f73513ea2872f0c9d2f65de2144.jpeg",
    "https://cdn.faire.com/fastly/7daa34acdcc209bc18507fb22b39022efbe3841881665b16bca57ddf99ddacc9.jpeg",
    "https://cdn.faire.com/fastly/b8ce2bccbd82ce01b079dec6e72822d94eac6d64152bdd14e2d7472c6944040e.jpeg",
    "https://cdn.faire.com/fastly/7d386f50d0e18a84f8182998b1877788bfa76402e0775ddb4af950e823bf8231.jpeg",
    "https://cdn.faire.com/fastly/bd26263cd2ff3a17f1118312a360640943e2ab66eeb1f18e2811521ad5103523.jpeg",
    "https://cdn.faire.com/fastly/d832610370df4b86bb602c4cf0e067b06e4d50e0370cbb73493f593a3a86f94d.jpeg",
    "https://cdn.faire.com/fastly/e799883db05e8b935795b4103d69d0b6f95a09991026380e20753a6f0d389d16.jpeg",
    "https://cdn.faire.com/fastly/49bd61d526c816dc8f106e2ecfbd0ac902931db1b0ee8bf63927cb5adc3c09b5.jpeg",
    "https://cdn.faire.com/fastly/4d30c1c086e453eaf0de2a551090c5b8841b997fc38b7a32e2747bbafb901413.jpeg",
    "https://cdn.faire.com/fastly/dae1c0c4da1ecf6575cc8f4d7da48c146b4f23a96713d24eae66e6766367b2e5.jpeg",
    "https://cdn.faire.com/fastly/5b41d1f390d9fc97c64cebfef0c8b4ddba013d8418b30c13869ad920dd0547dc.jpeg",
    "https://cdn.faire.com/fastly/6badb1db5767384656c474d1857875a30daef45b6ef1e9a2b8f2c9afee83d044.jpeg",
    "https://cdn.faire.com/fastly/156daeed410778d9a7c942a235af9510d638633018633feabfa46716b0f382f1.jpeg",
    "https://cdn.faire.com/fastly/ac567fa28117ab8ce03a214e7374f1818d3d3ddb786bc15a667c20cebd78d0c3.jpeg",
    "https://cdn.faire.com/fastly/0bac888d5cf9c839bdb9028d36c7b0686061bf12bf20d2747982017fe19eb1f2.jpeg",
  ],
  priceDollars: 114,
  description:
    "A casual yet refined short sleeve knit midi dress featuring a side slit for added movement and style. Crafted from soft, stretchy fabric, this dress offers a comfortable fit and a streamlined silhouette. Perfect for everyday wear, it easily transitions from day to night with the right accessories, blending simplicity with a touch of sophistication.\n\n• Model is 5'9\" and wearing a S/M",
  tags: [],
  msrpDollars: 228,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T06:19:50.440Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
